import Vue from 'vue';
import { Toolkit } from '@/util';

Vue.filter('maxStrLimit', function (value = '', max = 20) {
  return Toolkit.getLimitStr(value, max);
});
